<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-login-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Login',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreLoginView: () => import('../components/core/LoginView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
